import React, {useEffect} from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/styles';
import Modal from '@material-ui/core/Modal';


function getModalStyle() {
  const top = 50;
  const left = 50 ;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles(theme => ({
  progress: {
    margin: '0px',    
    justifyContent: 'center',
    color: '#ffffff'
    
  },
  paper: {
    position: 'absolute',
    width: 45,
    backgroundColor: '#33000000',
    outline: 'none',
  },
}));

export function Loading ({isLoading=false}){
  const classes = useStyles();
  const [modalStyle] = React.useState(getModalStyle);
  const [open, setOpen] = React.useState(isLoading);
  //console.log("start Loading")

  useEffect(()=>{
    if(isLoading !== open){
      setOpen(isLoading);
    }
  },[isLoading, open])
  return(

<div>
<Modal
  aria-labelledby="simple-modal-title"
  aria-describedby="simple-modal-description"
  open={open}
>
  <div style={modalStyle} className={classes.paper}>
    <CircularProgress className={classes.progress} color="inherit" />
  </div>
</Modal>
</div>
  )
}